import { render } from "./FbImage.vue?vue&type=template&id=239a24d3"
import script from "./FbImage.vue?vue&type=script&lang=js"
export * from "./FbImage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__